// extracted by mini-css-extract-plugin
export var teacher = "style-module--teacher--788c6";
export var teacher__img = "style-module--teacher__img--93a89";
export var teacher__info = "style-module--teacher__info--ff28d";
export var teacher__item = "style-module--teacher__item--46a44";
export var teacher__subtitle = "style-module--teacher__subtitle--9a21c";
export var teacher__title = "style-module--teacher__title--ad7b7";
export var teacher__wrap = "style-module--teacher__wrap--21429";